module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', {
    staticClass: "bg-gray-100 min-h-screen flex flex-col"
  }, [_c('div', {
    staticClass: "bg-gradient-to-b from-secondary to-primary"
  }, [_c('div', {
    staticClass: "px-2 py-3"
  }, [_c('app-header', {
    staticClass: "text-white",
    attrs: {
      "icon": "factory"
    }
  }, [_c('div', {
    staticClass: "flex items-center justify-between"
  }, [_c('h1', {
    staticClass: "text-2xl font-semibold tracking-wide"
  }, [_vm._v("Détenteurs")])])]), _vm._v(" "), _c('action-bar', {
    staticClass: "!p-0  mb-2",
    attrs: {
      "back": {
        name: 'home'
      }
    }
  }, [_c('router-link', {
    staticClass: "bg-white transition px-4 py-2 rounded-lg text-primary text-sm font-medium",
    attrs: {
      "to": {
        name: 'new-detenteur'
      },
      "id": "main-action"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.checkCanEdit('new-detenteur')
      }
    }
  }, [_vm._v("\n                Ajouter\n            ")])], 1), _vm._v(" "), _c('div', [_c('filter-bar', {
    staticClass: "block pb-5",
    attrs: {
      "placeholderFilter": "Rechercher par numéro, raison sociale…",
      "type-history": "detenteur"
    },
    on: {
      "searchBarChanged": _vm.updateSearch
    }
  })], 1)], 1)]), _vm._v(" "), _c('main', {
    staticClass: "bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 overflow-y-auto shadow-xl pb-28"
  }, [(_vm.asyncDetenteurs === true) ? _c('div', {
    staticClass: "px-4 pt-3"
  }, [_c('div', {
    staticClass: "flex items-center gap-2 text-sm text-gray-600 bg-white/70 backdrop-blur rounded-lg px-3 py-2 shadow"
  }, [_c('img', {
    staticClass: "h-4 w-4",
    attrs: {
      "src": require("../../img/spinner-load.gif"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("Synchronisation en cours en arrière plan")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mx-1 my-2 shadow-2xl rounded-lg overflow-hidden bg-white",
    attrs: {
      "id": "detenteurs-items"
    }
  }, _vm._l((_vm.paginatedList), function(detenteur) {
    return _c('detenteur-item', {
      key: detenteur.id,
      staticClass: "border-b last:border-b-0",
      attrs: {
        "detenteur": detenteur,
        "typeuser": _vm.typeUser
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "px-4 pb-6 mt-2 flex items-center justify-between gap-3"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paginator.showPreviousButton && !_vm.strSearch),
      expression: "paginator.showPreviousButton && !strSearch"
    }],
    staticClass: "px-4 py-2 rounded-lg border border-gray-300 bg-white text-gray-700 text-sm hover:bg-gray-50",
    on: {
      "click": _vm.previousPage
    }
  }, [_vm._v("\n                Page précédente\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-1"
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paginator.showNextButton && !_vm.strSearch),
      expression: "paginator.showNextButton && !strSearch"
    }],
    staticClass: "px-4 py-2 rounded-lg border border-gray-300 bg-white text-gray-700 text-sm hover:bg-gray-50",
    on: {
      "click": _vm.nextPage
    }
  }, [_vm._v("\n                Page suivante\n            ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11e228da","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detenteur/ListeDetenteurs.vue
// module id = 1004
// module chunks = 0